import React from "react";
import { Alert, Button, Modal, Space, Tag, Typography } from "antd";
import HoldToConfirmButton, { HOLD_CONFIRM_DURATION_MS } from "../../../../components/common/HoldToConfirmButton";

const { Text } = Typography;

export { HOLD_CONFIRM_DURATION_MS };

export const normalizeRiskWarnings = (riskWarnings = [], riskWarningDetails = []) => {
    const details = Array.isArray(riskWarningDetails) ? riskWarningDetails : [];
    const messages = Array.isArray(riskWarnings) ? riskWarnings : [];

    if (details.length > 0) {
        return details.map((warning, index) => {
            if (warning && typeof warning === "object") {
                return {
                    ...warning,
                    message: warning.message || messages[index] || warning.code || "存在可确认风险",
                };
            }
            return { message: messages[index] || String(warning || "存在可确认风险") };
        });
    }

    return messages.map((warning) => {
        if (warning && typeof warning === "object") {
            return {
                ...warning,
                message: warning.message || warning.code || "存在可确认风险",
            };
        }
        return { message: String(warning) };
    });
};

const ConfirmableRiskWarningModal = ({ open, title = "存在可确认风险", description, summary, warnings = [], confirmText = "长按 5 秒强制通过", cancelText = "取消", loading = false, onCancel, onConfirm, width = 640 }) => {
    const normalizedWarnings = normalizeRiskWarnings(warnings);

    return (
        <Modal
            title={title}
            open={open}
            width={width}
            onCancel={onCancel}
            footer={[
                <Button key="cancel" onClick={onCancel} disabled={loading}>
                    {cancelText}
                </Button>,
                <HoldToConfirmButton key="confirm" active={open} disabled={!open} loading={loading} onConfirm={onConfirm}>
                    {confirmText}
                </HoldToConfirmButton>,
            ]}
        >
            <Space direction="vertical" size={12} style={{ width: "100%" }}>
                <Alert
                    type="warning"
                    showIcon
                    message="这些风险由后端判定为可强制确认"
                    description={description || "请逐条核对风险明细。只有完成 5 秒长按后，前端才会发起带确认语义的提交请求。"}
                />
                {summary && <div>{summary}</div>}
                <div style={{ maxHeight: 360, overflowY: "auto" }}>
                    <ul style={{ margin: 0, paddingLeft: 20 }}>
                        {normalizedWarnings.map((warning, index) => (
                            <li key={`${warning.code || "risk"}-${index}`} style={{ marginBottom: 10 }}>
                                <Space size={6} wrap>
                                    {warning.subject && <Text strong>{warning.subject}</Text>}
                                    {warning.code && <Tag color="warning">{warning.code}</Tag>}
                                </Space>
                                <div style={{ marginTop: 4, color: "#595959", lineHeight: 1.5 }}>{warning.message}</div>
                            </li>
                        ))}
                    </ul>
                </div>
            </Space>
        </Modal>
    );
};

export default ConfirmableRiskWarningModal;
